import React, { FC } from 'react'
import { Box } from 'transfix-ui/core'
import { IMotorCarrierDetail } from 'apps/fleet-planner/types'

interface ITeamMemberCarrierDisplayProps {
  motorCarriers?: IMotorCarrierDetail[]
}

export const TeamMemberCarrierDisplay: FC<ITeamMemberCarrierDisplayProps> = ({
  motorCarriers = [],
}) => {
  const mcLength = motorCarriers.length
  const [firstCarrier] = motorCarriers || []
  const additionalCarriers = mcLength > 1 ? mcLength - 1 : undefined

  return (
    // display only if there are carriers
    mcLength > 0 ? (
      <Box component='span'>
        {firstCarrier?.legalName || ''}
        {additionalCarriers && (
          <span className='text-secondary'> and {additionalCarriers} more</span>
        )}
      </Box>
    ) : (
      <></>
    )
  )
}
